import { put, select } from 'redux-saga/effects';
import { websocketOpenSubscriptionById } from '../../websocketReducer';
import { getLiteTradeConfig, getLiteTradeSessionToken } from '../../../../modules/LiteTrade/liteTradeSelectors';
import { SOCKET_TYPE_MESSAGES, oppositeSubscriptionName } from '../../../../mobileAppCore/mobileAppConstants';
import { IMobileAppRootState } from '../../../../mobileAppCore/types/mobileAppState.t';
import { getIsAppVisibility, getUserAccounts } from '../../../../app/appSelectors';
import { setLiteTradeAccountMetrics } from '../../../../modules/LiteTrade/liteTradeActions';
import { getWebsocketSubscriptionById } from '../../websocketSelectors';
import _ from 'lodash';


function* subscriptionAccountMetricsSaga() {
    const liteTradeConfig = yield select(getLiteTradeConfig);
    const channel = liteTradeConfig?.wssUrl;
    const requestId = `_${SOCKET_TYPE_MESSAGES.ACCOUNT_METRICS_OPEN}`;
    const type = SOCKET_TYPE_MESSAGES.ACCOUNT_METRICS_OPEN;
    const accounts = yield select(getUserAccounts);
    const sessionToken = yield select(getLiteTradeSessionToken); 
    const isAppVisibility = yield select(getIsAppVisibility);
    const lastSubscription = yield select(getWebsocketSubscriptionById(channel, requestId));

    if (lastSubscription?.prev?.accounts && (lastSubscription?.state === 'open' || lastSubscription?.state === 'opening')) {
        const prevAccounts = lastSubscription.prev.accounts;
        if (_.isEqual(prevAccounts, accounts)) {
            return;
        }
    }
   
    if (accounts.length && isAppVisibility && sessionToken) {
        yield put(
            websocketOpenSubscriptionById({
                id: requestId,
                channel,
                prev: {
                    accounts,
                },
                open: function (state: IMobileAppRootState) {
                    const sessionToken = getLiteTradeSessionToken(state);
                    const accounts = getUserAccounts(state);
                    const accountCodes = accounts.map((item) => item.name);
                    return {
                        requestId,
                        type,
                        payload: {
                            accounts: accountCodes.map((accountCode) => `default:${accountCode}`),
                            includePositions: true,
                        },
                        session: sessionToken,
                    };
                },
                close: function (state: IMobileAppRootState) {
                    const sessionToken = getLiteTradeSessionToken(state);
                    return {
                        type: oppositeSubscriptionName[type],
                        refRequestId: requestId,
                        session: sessionToken,
                    };
                },
                process: function* (messageData: ReturnType<typeof JSON.parse>, channel: string) {
                    const metrics = messageData.payload.metrics || [];
                    for (let i = 0; i < metrics.length; i++) {
                        yield put(setLiteTradeAccountMetrics(metrics[i]));
                    }
                },
            }),
        );
    }
}

export default subscriptionAccountMetricsSaga;
